function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function formatSaleDate(ms) {
  var n = Number(ms);
  if (!n) {
    return '—';
  }
  var date = new Date(n);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString();
}
var _require = require('../web3-amount'),
  multiplyDecimalAmount = _require.multiplyDecimalAmount,
  web3SaleTicker = _require.web3SaleTicker;
function formatSaitoAmount(app, nolan) {
  try {
    var _app$wallet;
    var amount = BigInt(nolan !== null && nolan !== void 0 ? nolan : 0);
    if (amount > 0n && app !== null && app !== void 0 && (_app$wallet = app.wallet) !== null && _app$wallet !== void 0 && _app$wallet.convertNolanToSaito) {
      return "".concat(app.wallet.convertNolanToSaito(amount), " SAITO");
    }
    if (amount > 0n) {
      return String(amount);
    }
  } catch (err) {
    // fall through
  }
  return '';
}
function formatSaleAmount(app, summary, quantitySold) {
  var ticker = web3SaleTicker(summary === null || summary === void 0 ? void 0 : summary.web3_ticker);
  var unit = String((summary === null || summary === void 0 ? void 0 : summary.web3_amount) || '').trim();
  if (ticker && unit) {
    var total = multiplyDecimalAmount(unit, quantitySold);
    if (total !== '') {
      return "".concat(total, " ").concat(ticker);
    }
  }
  try {
    var _summary$price;
    return formatSaitoAmount(app, BigInt((_summary$price = summary === null || summary === void 0 ? void 0 : summary.price) !== null && _summary$price !== void 0 ? _summary$price : 0) * BigInt(quantitySold || 0));
  } catch (err) {
    return '';
  }
}
module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$listings = _ref.listings,
    listings = _ref$listings === void 0 ? [] : _ref$listings,
    _ref$caption = _ref.caption,
    caption = _ref$caption === void 0 ? 'Sales' : _ref$caption;
  var rows = (listings || []).map(function (summary) {
    var _summary$returnTitle, _summary$quantity_sol;
    var app = summary.app;
    var signature = escapeHtml(summary.listing_signature || '');
    var title = escapeHtml(((_summary$returnTitle = summary.returnTitle) === null || _summary$returnTitle === void 0 ? void 0 : _summary$returnTitle.call(summary)) || summary.title || 'Untitled Item');
    var quantity_sold = Math.max(0, Number((_summary$quantity_sol = summary.quantity_sold) !== null && _summary$quantity_sol !== void 0 ? _summary$quantity_sol : 0) || 0);
    var total = formatSaleAmount(app, summary, quantity_sold);
    var sold_at = escapeHtml(formatSaleDate(summary.sold_at));
    var buyer = String(summary.buyer || '').trim();
    var seller_note = String(summary.seller_note || '').trim();
    var buyer_html = '—';
    if (buyer) {
      var note_html = seller_note ? "<div class=\"sales-seller-note\">".concat(escapeHtml(seller_note), "</div>") : '';
      buyer_html = "\n            <div class=\"sales-buyer\">\n              <div class=\"sales-buyer-row\">\n                <span class=\"sales-buyer-address\" title=\"".concat(escapeHtml(buyer), "\">").concat(escapeHtml(buyer), "</span>\n                <button type=\"button\" class=\"saito-icon-button sales-buyer-copy\" data-action=\"copy-buyer\" data-buyer=\"").concat(escapeHtml(buyer), "\" title=\"Copy buyer address\" aria-label=\"Copy buyer address\">\n                  <i class=\"fas fa-copy\" aria-hidden=\"true\"></i>\n                </button>\n              </div>\n              ").concat(note_html, "\n            </div>");
    } else if (seller_note) {
      buyer_html = "<div class=\"sales-seller-note\">".concat(escapeHtml(seller_note), "</div>");
    }
    return "\n          <tr data-signature=\"".concat(signature, "\">\n            <td class=\"sales-title\">").concat(title, "</td>\n            <td>").concat(quantity_sold || '—', "</td>\n            <td>").concat(escapeHtml(total) || '—', "</td>\n            <td class=\"sales-buyer-cell\">").concat(buyer_html, "</td>\n            <td>").concat(sold_at, "</td>\n          </tr>");
  }).join('');
  var captionHtml = caption ? "<caption>".concat(escapeHtml(caption), "</caption>") : '';
  return "\n    <div class=\"listings-table-wrap\">\n      <table class=\"listings-table sales-table\">\n        ".concat(captionHtml, "\n        <thead>\n          <tr>\n            <th scope=\"col\">Title</th>\n            <th scope=\"col\">Qty</th>\n            <th scope=\"col\">Total</th>\n            <th scope=\"col\">Buyer</th>\n            <th scope=\"col\">Date</th>\n          </tr>\n        </thead>\n        <tbody>").concat(rows, "\n        </tbody>\n      </table>\n    </div>\n  ");
};